import { createUseStyles } from "react-jss";

export default createUseStyles({
    starRating: {
        composes: "star-rating",
        display: "flex",
        alignItems: "center",
        touchAction: "none",
        userSelect: "none",
        MsUserSelect: "none",
    },
    starRatingSpacer: {
        composes: "star-rating__spacer",
        verticalAlign: "middle",
        height: ({ starHeight }) => starHeight,
        width: 7,
    },
    starRatingStar: ({ theme, splitWidth, starHeight }) => ({
        color: theme.PrimaryColor,
        verticalAlign: "middle",
        composes: "star-rating__star",
        height: starHeight,
        overflow: "hidden",
        position: "relative",
        width: splitWidth,
    }),
});
